/**
 * Enum of supported Lottie animations.
 *
 * IMPORTANT:
 * - This enum must be exported outside of the player, as it's a client component.
 *   If not, importing it in a server component will return `undefined`.
 */

export enum LOTTIE_ANIMATION {
  AiiA_PromoBanner = 'aiia-promo-banner',
  AiiA_Footer = 'aiia-footer',
}
